import React, {useEffect, useState} from "react";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {Button, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

const UserProfile = () => {
    const [user, setUser] = useState({
        customerId: "",
        name: "",
        phoneNumber: "",
        shippingAddress: "",
        city: "",
        state: "",
        pinCode: "",
        landMark: "",
        selfPickup: false
    });

    const fetchUserAddress = async () => {
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.get(`${api.user}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                params: {
                    customerId: user.customerId
                }
            })
            if (response.status === 204) {
                alert("Customer ID is not found the user table ")
            }
            if (response.status === 200) {
                setUser({...user, ...response.data});
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                const refreshToken = getRefreshToken();

                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                try {
                    await refreshIdToken(refreshToken);
                    await fetchUserAddress();
                } catch (refreshErr) {
                    console.error("Token refresh failed:", refreshErr);
                    window.location.href = "/";
                }
            }
        }
    }
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setUser((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(user)
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.post(`${api.user}`, user, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
            })
            if (response.status === 200) {
                alert("Customer details is updated")
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                const refreshToken = getRefreshToken();

                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                try {
                    await refreshIdToken(refreshToken);
                    await handleSubmit();
                } catch (refreshErr) {
                    console.error("Token refresh failed:", refreshErr);
                    window.location.href = "/";
                }
            }
        }
    };

    return (
        <div>
            <Header/>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "100px",
                    marginLeft: "100px"
                }}
            >
                <Container className="mt-5">
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Customer ID</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    name="customerId"
                                                    value={user.customerId}
                                                    onChange={handleChange}
                                                    placeholder="Enter customer ID"
                                                    style={{width: '100px'}}
                                                />
                                                <InputGroup.Text onClick={fetchUserAddress} style={{cursor: 'pointer'}}>
                                                    <FontAwesomeIcon icon={faSearch}/>
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={user.name}
                                                onChange={handleChange}
                                                placeholder="Enter your name"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="phoneNumber"
                                                value={user.phoneNumber}
                                                onChange={handleChange}
                                                placeholder="Enter phone number"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Shipping Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="shippingAddress"
                                                value={user.shippingAddress}
                                                onChange={handleChange}
                                                placeholder="Enter shipping address"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="city"
                                                value={user.city}
                                                onChange={handleChange}
                                                placeholder="Enter city"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>State</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="state"
                                                value={user.state}
                                                onChange={handleChange}
                                                placeholder="Enter state"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>PIN Code</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pinCode"
                                                value={user.pinCode}
                                                onChange={handleChange}
                                                placeholder="Enter PIN code"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Landmark</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="landMark"
                                                value={user.landMark}
                                                onChange={handleChange}
                                                placeholder="Enter landmark"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3" style={{marginTop: "20px"}}>
                                    <Form.Check
                                        type="checkbox"
                                        name="selfPickup"
                                        checked={user.selfPickup}
                                        onChange={handleChange}
                                        label="Self Pickup"
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit">
                                    Save Profile
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default UserProfile;
